export default __webpack_public_path__ + "static/media/alcatraz-white.de9ca61f.png";